<template>
  <div>
    <h2 class="m-b-20 section-title">{{ label }}</h2>
    <div class="card m-b-40">
      <div class="row">
        <div>
          <GoodsType
            :value="3"
            @activeGoodsType="activeGoodsType"
          />
        </div>
      <!-- PACKAGE OPTIONS -->
      <div v-if="showColliContent">
        <div class="row m-b-40">
          <div class="col-xs-1" v-if="showColliAmount">
            <InputText
              :label="$t('Colli')"
              v-model="value.colli"
              :options="numbers"
              :rules="{required: true}"/>
          </div>
          <div :class="getPalletTypeClass">
            <InputSelect
              :label="$t('type')"
              v-model="value.palleteType"
              @change="palletTypeSelected"
              :options="palleteTypesSelection"
              :rules="{required: true}"/>
          </div>
          <div :class="value.pallet_stackable_type =='stacked' ? 'col-xs-3 m-b-20' : 'col-xs-2'">
            <InputSelect
              :label="$t('Stackable')"
              v-model="value.pallet_stackable_type"
              @change="stackSelected"
              :options="stackOptions"
              :rules="{required: true}"/>
          </div>
          <div class="col-xs-3 m-b-20" v-if="value.pallet_stackable_type == 'stacked'">
            <InputText
              :label="$t('Pallet space')"
              v-model="value.palletSpace"
              :rules="{required: true}"/>
          </div>
          <div :class="value.pallet_stackable_type =='stacked' ? 'col-xs-12' : 'col-xs-6'">
            <DimensionsSelect
              v-model="value.dimensions" />
          </div>
        </div>
        <div class="separator"></div>
        <!-- CONTENT ROW -->
        <div class="row m-b-40">
          <h2 class="col-xs-12 content-title m-b-20">{{ $t('content_title_pallet') }}</h2>
          <div class="col-xs-12">
            <ContentRow
              :showOnlyDescription="showOnlyDescription"
              :showOrigin="showOrigin"
              :showCustoms="showCustoms"
              :isCustomsInvoiceUploaded="isCustomsInvoiceUploaded"
              :class="value.content.length > (index + 1) ? 'm-b-20' : ''"
              v-for="(item, index) in value.content" :key="`row-${index}`"
              :deletable="value.content.length > 1"
              @setProductDetails="productSelected"
              @removeProduct="productRemoved"
              @quantityChange="quantityChange"
              :indexInData="index"
              @deleteRow="deleteRow"
              v-model="value.content[index]"
            />
          </div>
        </div>
      </div>
      <div v-if="!showColliContent">
        <div class="row m-b-40">
          <div class="col-xs-1" v-if="showColliAmount">
            <InputText
              :label="$t('Colli')"
              v-model="value.colli"
              :options="numbers"
              :rules="{required: true}"/>
          </div>
          <div :class="showColliAmount ? 'col-xs-3' : 'col-xs-4'">
            <InputSelect
              :label="$t('type')"
              v-model="value.palleteType"
              @change="palletTypeSelected"
              :options="palleteTypesSelection"
              :rules="{required: true}"/>
          </div>
          <div class="col-xs-5">
            <DimensionsSelect
              v-model="value.dimensions" />
          </div>
          <div class="col-xs-3">
            <WeightSelect
              :label="`${$t('weight_per')} ${$t('pallet').toLocaleLowerCase()}`"
              v-model="value.colliWeight"
              :rules="{required: true}"/>
          </div>
        </div>
        <div class="row m-b-40">
          <div :class="value.pallet_stackable_type =='stacked' ? 'col-xs-7 m-b-20' : 'col-xs-9'">
            <InputText
              :label="$t('desc')"
              v-model="value.description"
              :rules="{required: true}"
            />
          </div>
          <div class="col-xs-3 m-b-20">
            <InputSelect
              :label="$t('Stackable')"
              v-model="value.pallet_stackable_type"
              @change="stackSelected"
              :options="stackOptions"
              :rules="{required: true}"/>
          </div>
          <div class="col-xs-2 m-b-20" v-if="value.pallet_stackable_type == 'stacked'">
            <InputText
              :label="$t('Pallet space')"
              v-model="value.palletSpace"
              :rules="{required: true}"/>
          </div>
        </div>
      </div>
      <div class="separator" v-if="removable"></div>
      <!-- CONTENT ROW OPTIONS -->
      <div class="clear-float">
        <Btn
          v-if="showColliContent"
          @click.native="addContentItem"
          class="brand float-left m-r-20"
          :icon="{
            name: 'plus',
            size: '20',
          }"
          :btnText="$t('Add content')"
        />
        <Btn
          v-if="removable"
          @click.native="removePallete"
          class="gray float-left m-r-20"
          :icon="{
            name: 'deleteForever',
            size: '18',
          }"
          :btnText="$t('Remove pallete')"
        />
      </div>

        <booking-dg-block
          :value="value"
          :custom-id="customId"
          :dg-type-shown-on-package-custom-id="dgTypeShownOnPackageCustomId"
          :show-temperature="showTemperature"
          :show-dangerous-goods="showDangerousGoods"
          @input="$emit('input', $event)"
        />
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from "vuex";
import mixin from '@/mixins/mixins.js';
import Btn from '@/components/elements/buttons';
import InputText from '@/components/elements/inputs/text.vue';
import InputSelect from '@/components/elements/inputs/select.vue';
import DimensionsSelect from '@/components/elements/inputs/dimensionsSelect.vue';
import WeightSelect from '@/components/elements/inputs/weightSelect.vue';
import Toggle from "@/components/elements/inputs/toggle.vue";

import ContentRow from "@/components/shipments/contentRow.vue";
import DangerousGoodsBlock from "@/components/shipments/dangerousGoodsBlock";
import GoodsType from "@/components/shipments/goodsType.vue";
import productSelect from "@/mixins/productSelect";
import ProductPicker from "@/components/global/productPicker/productPicker.vue";
import BookingDgBlock from "@/components/shipments/bookingDgBlock.vue";

export default {
  name: 'PalleteBlock',
  mixins: [mixin,productSelect],
  components: {
    BookingDgBlock,
    ProductPicker,
    GoodsType,
    Btn,
    InputSelect,
    InputText,
    Toggle,
    DimensionsSelect,
    WeightSelect,
    ContentRow,
    DangerousGoodsBlock
  },
  props: {
    isCustomsInvoiceUploaded: {
      type: Boolean,
      default: false,
    },
    dgTypeShownOnPackageCustomId: {
      type: String,
      default: '',
    },
    showColliAmount: {
      type: Boolean,
      default: false,
    },
    showColliContent: {
      type: Boolean,
      default: false,
    },
    showTemperature: {
      type: Boolean,
      default: false,
    },
    showDangerousGoods: {
      type: Boolean,
      default: false,
    },
    customId: {
      type: String,
      default: '',
    },
     label: {
      type: String,
      default: 'Pallet',
    },
    removable: {
      type: Boolean,
      default: false,
    },
    showOrigin: {
      type: Boolean,
      default: false,
    },
    showCustoms: {
      type: Boolean,
      default: false,
    },
    showOnlyDescription: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      default: () => {
        return{
          goodsType: 3,
          colli: 1,
          description: '',
          palleteType: '',
          colliWeight: {
            value: 0,
            unit: 'kg',
          },
          dimensions: {
            width: {
              value: 0,
              disabled: false,
            },
            height: {
              value: 0,
              disabled: false,
            },
            length: {
              value: 0,
              disabled: false,
            },
            dimensionsType: 'cm',
          },
          isTemperature: false,
          minTemperature: '',
          maxTemperature: '',
          // stackablePallets: true,
          palletSpace: '',
          pallet_stackable_type: 'stackable',
          isDgToggleActive: false,
          qty: 1,
          Q: '',
          packingType: '',
          packingTypeOption: 2,
          isOverpack: 0,
          allPackedInOne: 2,
          iataLimitations: '',
          iataRadioactive: '',
          iataAdditionalInfo: '',
          dangerousGoodsServices: [
            {
              feeWrapperId: null,
              dangerousGoodsId: '',
              nemWeight: {
                unit: 'kg',
                value: null,
              },
              netWeight: {
                unit: 'kg',
                value: null,
              },
              bruttoWeight: {
                unit: 'kg',
                value: null,
              },
              englishTechnicalDesignation: '',
              danishTechnicalDesignation: '',
              iataAutorization: '',
              flashPoint: '',
              segregationGroup: '',
              ems: '',
              notAllInOneQty: '',
              notAllInOneOuterPackaging: '',
              innerPackaging: '',
              innerPackagingQty: '',
              packingInstruction: '',
              isEnvironmentalHazard: false,
              isMarinePollutant: false,
              isLimitedQuantity: false,
              isExceptedQuantity: false
            }
          ],
          content: [
            {
              qty: 1,
              description: '',
              unitWeight: {
                unit: 'kg',
                value: '',
              },
              unitValue: {
                value: '',
                unit: 'dkk',
              },
              hsCode: '',
              origin: '',
            },
          ],
        }
      },
    },
  },
  data() {
    return {
      stackOptions: [
        {text: this.$t('Stacked'), value: 'stacked'},
        {text: this.$t('Stackable'), value: 'stackable'},
        {text: this.$t('Non-Stackable'), value: 'non_stackable'},
      ],
    };
  },
  created() {
    this.$store.dispatch('GET_PALLETE_TYPES').then((res) => {
      if (this.value.palleteType === 'Pallet - unspecified') return;
      this.$emit('input', {
        ...this.value,
        dimensions: {
          width: {
            value: res[`${this.value.palleteType}`].width['value'],
            disabled: !res[`${this.value.palleteType}`].width['is_open'],
          },
          height: {
            value: this.value.dimensions.height.value,
            disabled: this.value.dimensions.height.disabled,
          },
          length: {
            value: res[`${this.value.palleteType}`].length['value'],
            disabled: !res[`${this.value.palleteType}`].length['is_open'],
          },
          dimensionsType: 'cm',
        },
      });
    });
  },
  computed: {
    ...mapGetters([
      'get_pallet_types',
    ]),
    getPalletTypeClass() {
      const isStackedPallet = (this.value.pallet_stackable_type == 'stacked');
      let classes = '';
      if (this.showColliContent) {
        if (isStackedPallet && this.showColliAmount) {
          classes = 'col-xs-3 m-b-20';
        } else if (isStackedPallet && !this.showColliAmount) {
          classes = 'col-xs-6 m-b-20';
        } else if (!isStackedPallet && this.showColliAmount) {
          classes = 'col-xs-3';
        } else if (!isStackedPallet && !this.showColliAmount) {
          classes = 'col-xs-4';
        }
      } else {
        if (isStackedPallet && this.showColliAmount) {
          classes = 'col-xs-2 m-b-20';
        } else if (isStackedPallet && !this.showColliAmount) {
          classes = 'col-xs-3 m-b-20';
        } else if (!isStackedPallet && this.showColliAmount) {
          classes = 'col-xs-5';
        } else if (!isStackedPallet && !this.showColliAmount) {
          classes = 'col-xs-6';
        }
      }

      return classes;
    },
  },
  methods: {
    stackSelected(val) {
      this.$emit('input', {
        ...this.value,
        pallet_stackable_type: val,
      });
    },
    addContentItem(){
      this.$emit('input', {
        ...this.value,
        content: [...this.value.content, {
          qty: 1,
          description: '',
          unitWeight: {
            value: '',
            unit: 'kg',
          },
          unitValue: {
            value: '',
            unit: 'dkk',
          },
          hsCode: '',
          origin: '',
        }]
      });
    },
    palletTypeSelected(palType) {
      this.$emit('input', {
        ...this.value,
        palleteType: palType,
        dimensions: {
          width: {
            value: this.get_pallet_types[palType].width['value'],
            disabled: !this.get_pallet_types[palType].width['is_open'],
          },
          height: {
            value: '',
            disabled: false,
          },
          length: {
            value: this.get_pallet_types[palType].length['value'],
            disabled: !this.get_pallet_types[palType].length['is_open'],
          },
          dimensionsType: this.get_pallet_types[palType].dimension_type || 'cm',
        },
      });
    },
    removePallete() {
      this.$emit('removePallet');
    },
    deleteRow(index) {
      this.$emit('input', {
        ...this.value,
        content: this.value.content.filter((item, idx) => idx !== index),
      });
    },
    activeGoodsType(val) {
      this.$emit('activePackageGoodsType', val);
    },
  },
  watch: {
    'showColliContent' (newVal, oldVal) {
      if (this.value && newVal && this.value.content.length < 1) {
        this.addContentItem()
      }
    }
  }
}
</script>
